<div class="flex flex-col gap-4 w-full">
    
    <p-card>
        <h1>Trip Journal | {{trip()?.groupName}} {{trip()?.tripDate | date}}</h1>
    </p-card>

    <div class="grid grid-cols-2 gap-3">
        <div class="col-span-2 md:col-span-1">
            <p-card>
                <ng-template pTemplate="header">
                    <h2>Trip info</h2>
                </ng-template>

                <div class="form-container form-container-underline label-semibold">
                    <div>
                        <label>Trip ID:</label>
                        <div>{{trip()?.id}}</div>
                    </div>
                    <div>
                        <label>Group Name:</label>
                        <div>{{trip()?.groupName}} from {{customer().city}} {{customer().stateprov}}</div>
                    </div>
                    <div>
                        <label>Group Leader:</label>
                        <div>{{trip()?.glName}}</div>
                    </div>
                    <div>
                        <label>Trip Date:</label>
                        <div>{{trip()?.tripDate | date}}</div>
                    </div>
                    <div>
                        <label>Location:</label>
                        <div>{{trip()?.location}}</div>
                    </div>
                    <div>
                        <label>Community:</label>
                        <div>{{communityList()}}</div>
                    </div>
                    <div>
                        <label>Partner:</label>
                        <div>{{partnerList()}}</div>
                    </div>
                    <div>
                        <label>Trip Leader:</label>
                        <div>{{trip()?.tlName}}</div>
                    </div>
                </div>

                <div class="grid grid-cols-2 gap-3">
                    @if (currentUser()?.roles?.includes("fullsite")) {
                    <div class="col-span-2 md:col-span-1">
                        <a href="{{trip()?.custId ?? 0 | contactCardUrl}}" target="_blank"><p-button styleClass="w-full" severity="warn"><span class="p-button-label"><fa-icon
                                    [icon]="icons.solid.faUsers"></fa-icon> View Contact Card</span></p-button></a>
                    </div>
                    }
                    <div class="col-span-2 md:col-span-1">
                        <a href="{{trip()?.id ?? 0 | tripJournalLink}}" target="_blank"><p-button styleClass="w-full" severity="info"><span class="p-button-label">
                                <fa-icon [icon]="icons.solid.faFileText"></fa-icon> View Live Journal
                            </span></p-button></a>
                    </div>
                </div>
              
            </p-card>
        </div>

        <div class="col-span-2 md:col-span-1">
            <p-card>
                <ng-template pTemplate="header">
                    <h2>Team Photo</h2>
                </ng-template>
                <div class="flex flex-col gap-3">
                    <app-group-photo [hasPhoto]="trip()?.hasGroupPhoto ? true : false" [tripId]="trip()?.id ?? -1"
                        (photoUploaded)="groupPhotoUploaded()"></app-group-photo>
                </div>
                <ng-template pTemplate="footer">

                </ng-template>
            </p-card>
        </div>
    </div>

    <p-card >
        <ng-template pTemplate="header">
            <div class="flex justify-between">
                <h2>Journal Entries</h2>
                <div>
                    <p-button severity="secondary" (click)="addJournalEntry()">
                        <span class="p-button-label"><fa-icon [icon]="icons.ppmSolid.add"></fa-icon> Add Journal
                            Entry</span>
                    </p-button>
                </div>
            </div>

        </ng-template>
        <div class="grid grid-cols-3 gap-3">
            @for (entry of entries(); track entry.id) {
            <div class="col-span-3 md:col-span-1">

                <p-card styleClass="journal-entry-card">
                    <ng-template pTemplate="header">
                        <span class="p-card-title">{{entry.entrytitle}}</span>
                    </ng-template>
                    <div class="flex flex-col gap-2">
                        <div>{{entry.author}}</div>
                        <div>{{entry.entrydate | date:'MMMM d, y \'at\' h:mm a'}}</div>
                        <div [innerHTML]="entry.entry | sanitizeHtml:'youtubeEmbed'"></div>
                        @if (entry.photo === 1) {
                        <img class="journal-entry-image" [src]="config.tripJournaPhotoUrl + '/' + trip()?.id + '/' + entry.id + '.jpg?v=' + photoCacheBust().get(entry.id)" />
                        }
                        <div class="grid grid-cols-2 gap-3">
                            <div class="col-span-2 md:col-span-1">
                                <p-button styleClass="w-full" severity="info" (click)="editEntryClicked(entry)">
                                    <span class="p-button-label"><fa-icon [icon]="icons.ppmSolid.edit"></fa-icon> Edit
                                        Entry</span>
                                </p-button>
                            </div>
                            <div class="col-span-2 md:col-span-1">
                                <p-button styleClass="w-full" severity="danger" (click)="deleteEntryClicked(entry)">
                                    <span class="p-button-label"><fa-icon [icon]="icons.ppmSolid.delete"></fa-icon>
                                        Delete Entry</span>
                                </p-button>
                            </div>
                        </div>
                    </div>
                </p-card>
            </div>
            }


        </div>
        <div class="grid grid-cols-5 mt-4">
            <div class="col-span-5 md:col-span-3 md:col-start-2">
                <p-button styleClass="w-full"  (click)="addJournalEntry()">
                    <span class="p-button-label"><fa-icon [icon]="icons.ppmSolid.add"></fa-icon> Add Journal
                        Entry</span>
                </p-button>
            </div>
        </div>
    </p-card>

    <p-dialog #journalDialog [(visible)]="journalDialogVisible" appendTo="body" [modal]="true" [header]="editEntry() ? 'Edit Journal Entry' : 'New Journal Entry'" [style]="{width: '50vw'}" [breakpoints]="{ '1199px': '75vw', '575px': '95vw' }">
        <app-trip-journal-edit #journalEdit [trip]="trip()" [editEntry]="editEntry()" (entryCreated)="entryCreated($event)" (entryEdited)="entryEdited($event)" (cancel)="cancelEdit()"></app-trip-journal-edit>
    </p-dialog>

</div>